import React from 'react'
import moment from 'moment'
import {polyglot} from '../index'
import PanelWithContent from '../components/common/PanelWithContent/PanelWithContent'

export const AGE = {
  ZERO_TWO: 'zeroTwo',
  ZERO_FIVE: 'zeroFive',
  TWO_FIVE: 'twoFive',
  FIVE_TEN: 'fiveTen',
  FIVE_NINETEEN: 'fiveNineteen',
  getAge: (type = '') => {
    switch (type) {
      case AGE.ZERO_TWO:
        return AGE.ZERO_TWO
      case AGE.ZERO_FIVE:
        return GENDER.ZERO_FIVE
      case AGE.TWO_FIVE:
        return AGE.TWO_FIVE
      case AGE.FIVE_TEN:
        return AGE.FIVE_TEN
      case AGE.FIVE_NINETEEN:
        return AGE.FIVE_NINETEEN
      default:
        return undefined
    }
  }
}

export const alertOptions = {
  offset: 14,
  position: 'bottom left',
  theme: 'dark',
  time: 5000,
  transition: 'scale'
}

const GENDER = {
  GIRL: 'female',
  BOY: 'male',
  getGender: (type = '') => {
    switch (type) {
      case GENDER.GIRL:
        return GENDER.GIRL
      case GENDER.BOY:
        return GENDER.BOY
      default:
        return undefined
    }
  }
}

export { GENDER }

export function isDateInputAvailable () {
  let input = document.createElement('input')
  input.setAttribute('type', 'date')

  let notADateValue = 'not-a-date'
  input.setAttribute('value', notADateValue)

  return (input.value !== notADateValue)
}

export function getFormattedDate (date, formatType) {
  return moment(date).format(formatType)
}

export function renderContent (data) {
  return data.map(element => {
    return <PanelWithContent
      extraFieldContent={element.extraFieldContent}
      saveData={() => {}}
      key={element.key}
      dataKey={element.key}
      title={element.title}
      fields={element.fields}
      extraFieldEnabled={element['isExtraFieldEnabled']} />
  })
}

export function getFormattedBirthDate (birthday) {
  return moment(birthday).format('LL')
}

export function getAgeDescription (birthday) {
  const patientBirthDay = moment(birthday)
  const years = moment().diff(patientBirthDay, 'years', false)
  if (years > 0) {
    return `${polyglot.t('staticFields.numYears', {smart_count: years})}`
  } else {
    const months = moment().diff(patientBirthDay, 'months', false)
    if (months > 0) {
      return `${polyglot.t('staticFields.numMonths', {smart_count: months})}`
    } else {
      const days = moment().diff(patientBirthDay, 'days', false)
      return `${polyglot.t('staticFields.numDays', {smart_count: days})}`
    }
  }
}

export function getAgeDescriptionForDate (birthday, date) {
  const patientBirthDay = moment(birthday)
  const endDate = moment(date)
  const years = endDate.diff(patientBirthDay, 'years', false)
  if (years > 2) {
    return `${polyglot.t('staticFields.numYears', {smart_count: years})}`
  } else {
    const months = endDate.diff(patientBirthDay, 'months', false)
    if (months > 0) {
      return `${polyglot.t('staticFields.numMonths', {smart_count: months})}`
    } else {
      const days = endDate.diff(patientBirthDay, 'days', false)
      return `${polyglot.t('staticFields.numDays', {smart_count: days})}`
    }
  }
}

export function getValueBetweenDates (birthday, date) {
  const patientBirthDay = moment(birthday)
  const endDate = moment(date)
  const years = endDate.diff(patientBirthDay, 'years', false)
  if (years > 2) {
    return { type: 'years', value: years }
  } else {
    const months = endDate.diff(patientBirthDay, 'months', false)
    if (months > 0) {
      return { type: 'months', value: months }
    } else {
      const days = endDate.diff(patientBirthDay, 'days', false)
      return { type: 'days', value: days }
    }
  }
}

export function getDaysBetweenDates (birthday, date) {
  const patientBirthDay = moment(birthday)
  const endDate = moment(date)
  const days = endDate.diff(patientBirthDay, 'days', false)
  return { type: 'days', value: days }
}

export function getDurationBetweenDates (birthday, date) {
  const patientBirthDay = moment(new Date(birthday))
  const endDate = moment(new Date(date))
  // const days = endDate.diff(patientBirthDay, 'days', false)
  // const months = endDate.diff(patientBirthDay, 'months', false)
  // const years = endDate.diff(patientBirthDay, 'years', false)
  // return {days: days, months: months, years: years}
  return moment.duration(endDate.diff(patientBirthDay))
}

export function getMonthsBetweenDates (birthday, date) {
  const patientBirthDay = moment(birthday)
  const endDate = moment(date)
  const months = endDate.diff(patientBirthDay, 'months', false)
  return { type: 'months', value: months }
}

export function calculateWeeksBetweenDates (start, end) {
  const startMoment = moment(start)
  const endMoment = moment(end)
  return endMoment.diff(startMoment, 'week')
}

export function calculateDaysFromDate (dateString) {
  const date = moment(dateString)
  const today = moment()
  return today.diff(date, 'day')
}

export function calculateWeeksFromDate (dateString) {
  const date = moment(dateString)
  const today = moment()
  return today.diff(date, 'week')
}

export function weeksToString (value) {
  return `${polyglot.t('staticFields.numWeeks', {smart_count: value})}`
}

export function daysToString (value) {
  return `${polyglot.t('staticFields.numDays', {smart_count: value})}`
}

export function cleanArray (actual) {
  let newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

export function checkSelected (elements, value) {
  if (elements && elements !== null) {
    return elements.indexOf(value) !== -1
  } else {
    return false
  }
}

/**
 * @return {boolean}
 */
export function isJsonString (str) {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}



// WEBPACK FOOTER //
// ./src/resources/utilities.js